export default __webpack_public_path__ + "static/media/4th-parade-2025-2.4dcc0c9a.jpeg";